import { ColProps } from '@main/core-ui';

/**
 * Layout for sider
 */
export const SIDER_LAYOUT: ColProps = { span: 24, md: 9, lg: 8, xl: 7, xxl: 6 };

/**
 * Layout for page content
 */
export const CONTENT_LAYOUT: ColProps = {
  span: 24,
  md: 15,
  lg: 16,
  xl: 17,
  xxl: 18,
};
